import React from 'react'

// material ui
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import TextField from '@mui/material/TextField'

// components
import Typography from '@mui/material/Typography'

// shared components
import FormTextFieldWithValidation from 'components/shared/FormTextFieldWithValidation'

const SelectCustomAllergies = props => {
  const { food, severe, form, onChangeCustomAllergyField, formErrors } = props

  const typeLabel = food ? 'food' : 'non-food'
  const severityLabel = severe ? 'severe' : 'moderate'
  const customAllergyKey = `custom_allergy_${typeLabel}_${severityLabel}`

  const camperCustomAllergies = (form.camperAllergies || []).filter(
    a =>
      a.custom && (food ? a.food : !a.food) && (severe ? a.severe : !a.severe)
  )

  const customAllergyTemplate = {
    food,
    severe,
    name: '',
    custom: true
  }

  const customAllergies =
    camperCustomAllergies.length > 0
      ? camperCustomAllergies
      : [customAllergyTemplate]

  if (form[customAllergyKey] === undefined) {
    customAllergies.forEach(allergy => {
      form[customAllergyKey] = allergy.name
    })
  }
  return (
    <>
      {customAllergies.map(allergy => (
        <FormControl
          key={`${allergy.food}-${allergy.severe}`}
          fullWidth
          margin='normal'
          required={false}
        >
          <FormLabel htmlFor={customAllergyKey}>
            Any other{' '}
            <Typography display='inline' fontWeight='fontWeightBold'>
              {severityLabel} {typeLabel}
            </Typography>{' '}
            allergies
          </FormLabel>
          <FormTextFieldWithValidation
            label=''
            form={form}
            field={customAllergyKey}
            onChange={onChangeCustomAllergyField}
            errors={formErrors}
          />
        </FormControl>
      ))}
    </>
  )
}

export default SelectCustomAllergies
